import React, { useRef, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import TableChartIcon from '@mui/icons-material/TableChart';
import GridViewIcon from '@mui/icons-material/GridView';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AnalystTabBar = ({ tabs, activeTabId, onSelectTab, onCloseTab, onNewTab, onShowGallery }) => {
  const scrollRef = useRef(null);

  // Auto-scroll to the active tab
  useEffect(() => {
    if (!scrollRef.current) return;
    const activeEl = scrollRef.current.querySelector(`[data-tab-id="${activeTabId}"]`);
    if (activeEl) activeEl.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
  }, [activeTabId]);

  return (
    <div className="flex items-center bg-gray-100 border-t border-gray-200 h-10 flex-shrink-0">
      {/* Scrollable tabs */}
      <div ref={scrollRef} className="flex-1 flex items-center overflow-x-auto scrollbar-none">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            data-tab-id={tab.id}
            onClick={() => onSelectTab(tab.id)}
            className={`group flex items-center gap-1.5 h-full px-3 min-w-[130px] max-w-[220px] text-sm whitespace-nowrap border-r border-gray-200 transition-colors ${
              tab.id === activeTabId
                ? 'bg-white text-gray-800 shadow-[inset_0_2px_0_0] shadow-brand-pink'
                : 'text-gray-500 hover:bg-gray-200/60 hover:text-gray-700'
            }`}
          >
            <TableChartIcon
              style={{ fontSize: '15px' }}
              className={tab.id === activeTabId ? 'text-brand-pink' : 'text-gray-400'}
            />
            <span className="truncate flex-1 text-left">
              {tab.name}
            </span>
            {tab.threadId && (
              <span className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" title="Thread active" />
            )}
            {tabs.length > 1 && (
              <span
                role="button"
                onClick={(e) => { e.stopPropagation(); onCloseTab(tab.id); }}
                className={`flex-shrink-0 rounded p-0.5 transition-colors ${
                  tab.id === activeTabId
                    ? 'hover:bg-gray-100 text-gray-400 hover:text-gray-600'
                    : 'opacity-0 group-hover:opacity-100 hover:bg-gray-300/50 text-gray-400'
                }`}
                title="Close tab"
              >
                <CloseIcon style={{ fontSize: '14px' }} />
              </span>
            )}
          </button>
        ))}
      </div>

      {/* New tab button */}
      <button
        onClick={onNewTab}
        className="flex items-center justify-center w-10 h-full text-gray-400 hover:text-brand-pink hover:bg-gray-200/60 transition-colors border-l border-gray-200"
        title="New sheet"
      >
        <AddIcon style={{ fontSize: '18px' }} />
      </button>
    </div>
  );
};

export default AnalystTabBar;
